// Core "league not found" screen: no tenant resolved for this host, so no
// template exists yet. Verbatim from App.tsx's LeagueNotFound.

import { useT } from '@/i18n'
import { siteCoreMessages } from '@/i18n/catalogs/site-core'

export default function CoreNotFound() {
  const t = useT(siteCoreMessages).pages.leagueNotFound
  return (
    <div className="min-h-screen bg-gradient-to-b from-bg-secondary via-bg-primary to-bg-primary flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <h1 className="font-['Montserrat'] font-black text-3xl tracking-tight text-white mb-3">
          {t.title}
        </h1>
        <p className="text-white/60 text-sm">
          {t.body}
        </p>
      </div>
    </div>
  )
}
